module.exports = "{{token}}\r\n\r\n"